const state = {
  loanSelected: null,
  reloadLoanTable: false,
  applicantSelected: null,
  reloadOTable: false,

  // reason cancel list
  toggle_reason_cancel_list_modal: false,
  applicable_id: null,
  product: null,
  fetchData: false
}

const getters = {
  getApplicantSelected () {
    return state.applicantSelected
  },
  getReloadOTable () {
    return state.reloadOTable
  },

  getLoanSelected () {
    return state.loanSelected
  },
  getReloadLoanTable () {
    return state.reloadLoanTable
  },
  fetchData: state => state.fetchData
}

const mutations = {
  SET_APPLICANT_SELECTED (state, applicant) {
    state.applicantSelected = applicant
  },
  SET_RELOAD_OTABLE (state, value) {
    state.reloadOTable = value
  },

  SET_LOAN_SELECTED (state, loan) {
    state.loanSelected = loan
  },
  SET_RELOAD_LOAN_TABLE (state, value) {
    state.reloadLoanTable = value
  },
  toggleReasonCancelListModal (state) {
    state.toggle_reason_cancel_list_modal = !state.toggle_reason_cancel_list_modal
  },
  setApplicableId (state, id) {
    state.applicable_id = id
  },
  setBorrowProduct (state, product) {
    state.product = product
  },
  set_applicable_id_product (state, { applicantSelected, product }) {
    state.applicantSelected = applicantSelected
    state.product = product
    state.fetchData = !state.fetchData
  }
}

const actions = {
  set_applicable_id_product ({ commit }, { applicantSelected, product }) {
    commit('set_applicable_id_product', { applicantSelected, product })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
